import { render, staticRenderFns } from "./DealDocumentsTab.vue?vue&type=template&id=c6f0c5a0"
import script from "./DealDocumentsTab.vue?vue&type=script&lang=js"
export * from "./DealDocumentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports